export const chartType = {
  COLUMN: 'column',
  PIE: 'pie',
  LINE: 'line',
  BAR: 'bar',
  HEATMAP: 'heatmap',
  AREA: 'area'
};

// Highcharts option constants
export enum StackingOptions {
  NORMAL = 'normal',
  PERCENT = 'percent'
}

export enum PresentationType {
  Table = 1,
  Highcharts = 2,
  Tile = 4,
  RiskReport = 6
}

export enum ColumnType {
  selection = 'selection',
  aggregation = 'aggregation',
  target = 'target',
  aggregationRollAvg = 'aggregationRollAvg'
}

export enum Period {
  Year = 1,
  Quarter = 2,
  Month = 3,
  Week = 4,
  Day = 5,
  Weekday = 6
}

export enum FavouriteLayoutTypeContext {
  SelectionReport = 1,
  Dashboard = 2
}

export const defaultChartHeight = 400;
export const maxChartHeight = 3000;
